module.exports = __webpack_public_path__ + "img/Razor.c6ae765d.png";